import { apiClient } from './apiClient';

export const response = (payload) => {
  if (payload && Array.isArray(payload.results)) {
    const nextPage = payload.next
      ? Number(new URL(payload.next).searchParams.get('page') || 2)
      : null;
    const previousPage = payload.previous
      ? Number(new URL(payload.previous).searchParams.get('page') || 1)
      : null;
    const page = nextPage ? nextPage - 1 : previousPage ? previousPage + 1 : 1;
    const pageSize = payload.results.length || payload.count || 1;
    return {
      data: payload.results,
      meta: {
        total: payload.count,
        count: payload.results.length,
        next: payload.next,
        previous: payload.previous,
        page,
        pageSize,
        totalPages: Math.max(1, Math.ceil(payload.count / pageSize)),
      },
    };
  }
  return { data: payload };
};

export const call = async (method, path, payload, params, options = {}) => {
  const normalizedParams = { ...(params || {}) };
  if (normalizedParams.pageSize !== undefined) {
    normalizedParams.page_size = normalizedParams.pageSize;
    delete normalizedParams.pageSize;
  }
  const result = method === 'get' || method === 'delete'
    ? await apiClient[method](path, { ...options, params: normalizedParams })
    : await apiClient[method](path, payload, { ...options, params: normalizedParams });
  return response(result);
};

export const restService = (resource) => ({
  getAll: (params) => call('get', `${resource}/`, null, params),
  getById: (id) => call('get', `${resource}/${id}/`),
  create: (payload) => call('post', `${resource}/`, payload),
  update: (id, payload) => call('patch', `${resource}/${id}/`, payload),
  remove: (id) => call('delete', `${resource}/${id}/`),
  search: (query) => call('get', `${resource}/`, null, { search: query }),
  getPaginated: ({ page = 1, pageSize = 20, ...params } = {}) =>
    call('get', `${resource}/`, null, { page, page_size: pageSize, ...params }),
  getByCoordinator: (id) =>
    call('get', `${resource}/`, null, { coordinador_id: id }),
  getByLeader: (id) => call('get', `${resource}/`, null, { puntero_id: id }),
});
